import type { useToast } from 'primevue/usetoast'
import type { useConfirm } from 'primevue/useconfirm'

export const usePrimevueToast = () => {
  const nuxtApp = useNuxtApp()
  const getToast: typeof useToast = () => nuxtApp.vueApp.config.globalProperties.$toast
  const toastService = getToast()
  return toastService
}

export const usePrimevueConfirm = () => {
  const nuxtApp = useNuxtApp()
  const getConfirm: typeof useConfirm = () => nuxtApp.vueApp.config.globalProperties.$confirm
  const confirmationService = getConfirm()
  return confirmationService
}
